export default "__VITE_ASSET__Cel8jbQF__"